import React from 'react';
import PropTypes from 'prop-types';
import WebComponent from './WebComponent';

export default function SuperbadgeContentList({ challenges, recommendedLearningItems }) {
  return (
    <WebComponent
      tagName="th-superbadge-content-list"
      attrs={{ challenges, recommendedLearningItems }}
    />
  );
}

SuperbadgeContentList.propTypes = {
  challenges: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      estimatedTime: PropTypes.number,
      path: PropTypes.string,
      user: PropTypes.shape({
        finishedAt: PropTypes.string,
        pointsEarned: PropTypes.number,
      }),
    })
  ).isRequired,
  recommendedLearningItems: PropTypes.arrayOf(
    PropTypes.shape({
      summary: PropTypes.object.isRequired,
      action: PropTypes.object,
    })
  ).isRequired,
};
